import { Controller } from "@hotwired/stimulus"

// Full-screen success celebration (shared/_celebration). Plays once per
// onceKey (sessionStorage) — Turbo morphs may re-insert the element while the
// triggering condition is still fresh, and a replayed overlay reads as a bug.
// Tap anywhere dismisses early. duration = total ms before self-removal.
export default class extends Controller {
  static values = { onceKey: String, duration: { type: Number, default: 3500 } }

  connect() {
    const key = `celebration:${this.onceKeyValue}`
    if (this.onceKeyValue && sessionStorage.getItem(key)) {
      this.element.remove()
      return
    }
    if (this.onceKeyValue) sessionStorage.setItem(key, "1")

    this.element.addEventListener("click", () => this.dismiss(), { once: true })
    this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    clearTimeout(this.timeout)
    this.element.classList.add("celebration-leave")
    // Matches .celebration-leave's fade-out duration in application.tailwind.css.
    setTimeout(() => this.element.remove(), 300)
  }
}
